// Hashiwokakero (Bridges) generator & validator
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function makeHashi(size, targetIslands) {
  const R = size, C = size;
  const islandAt = Array.from({ length: R }, () => Array(C).fill(-1));
  const occH = Array.from({ length: R }, () => Array(C).fill(false));
  const occV = Array.from({ length: R }, () => Array(C).fill(false));
  const islands = [];
  const solEdges = [];
  const add = (r, c) => { const id = islands.length; islands.push({ id, r, c, value: 0 }); islandAt[r][c] = id; return id; };
  add(Math.floor(R / 2), Math.floor(C / 2));

  let tries = 0;
  while (islands.length < targetIslands && tries < 4000) {
    tries++;
    const base = islands[Math.floor(Math.random() * islands.length)];
    let done = false;
    for (const [dr, dc] of shuffle([[0, 1], [0, -1], [1, 0], [-1, 0]])) {
      const orient = dr !== 0 ? "V" : "H";
      const limit = dr !== 0 ? R : C;
      for (let d = 2; d < limit; d++) {
        const r = base.r + dr * d, c = base.c + dc * d;
        if (r < 0 || c < 0 || r >= R || c >= C) break;
        let blocked = false, crossed = false;
        for (let k = 1; k < d; k++) {
          const rr = base.r + dr * k, cc = base.c + dc * k;
          if (islandAt[rr][cc] !== -1) { blocked = true; break; }
          if (orient === "H" && occV[rr][cc]) crossed = true;
          if (orient === "V" && occH[rr][cc]) crossed = true;
        }
        if (blocked || crossed) break;
        if (islandAt[r][c] !== -1) break;
        if (occH[r][c] || occV[r][c]) continue; // don't place an island on top of a bridge
        const id = add(r, c);
        const count = Math.random() < 0.3 ? 2 : 1;
        for (let k = 1; k < d; k++) {
          const rr = base.r + dr * k, cc = base.c + dc * k;
          if (orient === "H") occH[rr][cc] = true; else occV[rr][cc] = true;
        }
        islands[base.id].value += count;
        islands[id].value += count;
        solEdges.push({ a: base.id, b: id, count });
        done = true;
        break;
      }
      if (done) break;
    }
  }
  return { size, islands, solEdges };
}

export function candidateEdges(islands, size) {
  const at = {};
  islands.forEach((i) => { at[`${i.r},${i.c}`] = i.id; });
  const edges = [];
  for (const isl of islands) {
    for (let c = isl.c + 1; c < size; c++) {
      const id = at[`${isl.r},${c}`];
      if (id !== undefined) { edges.push({ a: isl.id, b: id, orient: "H", r: isl.r, c1: isl.c, c2: c }); break; }
    }
    for (let r = isl.r + 1; r < size; r++) {
      const id = at[`${r},${isl.c}`];
      if (id !== undefined) { edges.push({ a: isl.id, b: id, orient: "V", c: isl.c, r1: isl.r, r2: r }); break; }
    }
  }
  return edges;
}

export function edgesCross(e1, e2) {
  if (e1.orient === e2.orient) return false;
  const h = e1.orient === "H" ? e1 : e2;
  const v = e1.orient === "H" ? e2 : e1;
  return v.c > Math.min(h.c1, h.c2) && v.c < Math.max(h.c1, h.c2) && h.r > Math.min(v.r1, v.r2) && h.r < Math.max(v.r1, v.r2);
}

export function hashiWin(islands, edges, counts) {
  const deg = {};
  islands.forEach((i) => { deg[i.id] = 0; });
  edges.forEach((e, idx) => { const cnt = counts[idx] || 0; deg[e.a] += cnt; deg[e.b] += cnt; });
  for (const i of islands) if (deg[i.id] !== i.value) return false;
  const adj = {};
  islands.forEach((i) => { adj[i.id] = []; });
  edges.forEach((e, idx) => { if ((counts[idx] || 0) > 0) { adj[e.a].push(e.b); adj[e.b].push(e.a); } });
  const seen = new Set([islands[0].id]);
  const st = [islands[0].id];
  while (st.length) { const x = st.pop(); for (const y of adj[x]) if (!seen.has(y)) { seen.add(y); st.push(y); } }
  return seen.size === islands.length;
}
